const CAPTURE_FRAMES_PER_CHUNK = 100;
type ChunkFrame = { seq: number; pcm: ArrayBuffer };
export const MIN_ENROLMENT_MS = 30_000;
export const MAX_ENROLMENT_MS = 90_000;
export const MAX_ENROLMENT_CHUNKS = MAX_ENROLMENT_MS / 1000 / 10;
export const elapsedSeconds = (startedAt: number, now = Date.now()) =>
  Math.max(0, Math.floor((now - startedAt) / 1000));
export const formatElapsed = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
export const chunkFrames = (frames: ChunkFrame[], maxChunks = MAX_ENROLMENT_CHUNKS) => {
  const bounded = frames.slice(0, maxChunks * CAPTURE_FRAMES_PER_CHUNK);
  const chunks: ChunkFrame[][] = [];
  for (let offset = 0; offset < bounded.length; offset += CAPTURE_FRAMES_PER_CHUNK)
    chunks.push(bounded.slice(offset, offset + CAPTURE_FRAMES_PER_CHUNK));
  return chunks;
};
